import React from 'react'
import { Container } from 'react-bootstrap'
import {PAGE_NOT_FOUND_MESSAGE} from 'constants/messages'

const NotFoundPage = () => (
  <>
    <div className="bg-triangle"  />
    <div style={{display:'flex',justifyContent:'center', marginTop:'30px'}}><img src='images/Oly.svg' style={{maxHeight:'170px'}} /></div>
    
    <Container className="notfound-container p-5 mb-2 shadow-sm" style={{backgroundColor:'#FF1261', marginTop:'30px'}}>
      <div style={{color:'#000', borderLeft:'6px solid #000', paddingLeft:'6px'}}>{PAGE_NOT_FOUND_MESSAGE}</div>
    </Container>
  </>
)

export default NotFoundPage
